"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var DirectionDown_1 = require("../../Icons/DirectionDown");
var NormalCheck_1 = require("../../Icons/NormalCheck");
var NormalClose_1 = require("../../Icons/NormalClose");
var NormalLoading_1 = require("../../Icons/NormalLoading");
var NormalSearch_1 = require("../../Icons/NormalSearch");
var PromptCloseCircleFill_1 = require("../../Icons/PromptCloseCircleFill");
function getIcons(_a) {
    var suffixIcon = _a.suffixIcon, clearIcon = _a.clearIcon, menuItemSelectedIcon = _a.menuItemSelectedIcon, removeIcon = _a.removeIcon, loading = _a.loading, multiple = _a.multiple, prefixCls = _a.prefixCls;
    // Clear Icon
    var mergedClearIcon = clearIcon;
    if (!clearIcon) {
        mergedClearIcon = React.createElement(PromptCloseCircleFill_1.PromptCloseCircleFill, null);
    }
    // Arrow item icon
    var mergedSuffixIcon = null;
    if (suffixIcon !== undefined) {
        mergedSuffixIcon = suffixIcon;
    }
    else if (loading) {
        mergedSuffixIcon = React.createElement(NormalLoading_1.NormalLoading, { spin: true });
    }
    else {
        var iconCls_1 = "".concat(prefixCls, "-suffix");
        mergedSuffixIcon = function (_a) {
            var open = _a.open, showSearch = _a.showSearch;
            if (open && showSearch) {
                return React.createElement(NormalSearch_1.NormalSearch, { className: iconCls_1 });
            }
            return React.createElement(DirectionDown_1.DirectionDown, { className: iconCls_1 });
        };
    }
    // Checked item icon
    var mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) {
        mergedItemIcon = menuItemSelectedIcon;
    }
    else if (multiple) {
        mergedItemIcon = React.createElement(NormalCheck_1.NormalCheck, null);
    }
    else {
        mergedItemIcon = null;
    }
    var mergedRemoveIcon = null;
    if (removeIcon !== undefined) {
        mergedRemoveIcon = removeIcon;
    }
    else {
        mergedRemoveIcon = React.createElement(NormalClose_1.NormalClose, null);
    }
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon,
    };
}
exports.default = getIcons;
//# sourceMappingURL=iconUtil.js.map